<script>
import { forEach } from "lodash";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Swal },
    props:{
        titulo:'',
        productos:{
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            windowWidth3: window.innerWidth,
            windowHeight3: window.innerHeight
        };
    },
    created(){

    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize() {
            this.windowWidth3 = window.innerWidth;
            this.windowHeight3 = window.innerHeight;
        },
        agregar_carro(producto){
            //producto.cantidad=1
            producto.imagen=producto.foto_dir
            producto.producto_id=producto.id
            if(producto.precio_rebajado==null){
                producto.precio = producto.precio_normal
            }else{
                producto.precio = producto.precio_rebajado
            }
            localStorage.setItem('orden',JSON.stringify(producto));
            this.$store.dispatch('addToCart', producto);
            const orden = localStorage.getItem("orden");
            //console.log(JSON.parse(orden));
            if(producto.promocion){
                if(producto.prom_tipo=='producto'){
                    if(producto.promo_prod.tipo=='comprexllevey' && producto.cantidad==producto.promo_prod.cantidad ){
                        //console.log(this.seleccion);
                        let regalo = {
                            cantidad:parseInt(producto.promo_prod.cant_regalar),
                            codigo_var:producto.promo_prod.regalo.codigo,
                            imagen:producto.promo_prod.regalo.foto_dir,
                            marca:producto.promo_prod.regalo.marca,
                            nombre:producto.promo_prod.regalo.nombre,
                            precio:0,
                            precio_normal:0,
                            precio_rebajado:0,
                            producto_id:producto.promo_prod.regalo.id,
                            stock:producto.promo_prod.regalo.stock,
                            tipo:producto.promo_prod.regalo.tipo,
                            titulo:producto.promo_prod.regalo.nombre,
                            promocion:producto.producto_id
                        }
                        localStorage.setItem('orden',JSON.stringify(regalo));
                        this.$store.dispatch('addToCart', regalo);
                    }
                }
            }
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Se ha agregado un producto",
                showConfirmButton: false,
                timer: 1500
            });
            //window.location.reload();
        },
        increaseQuantity(index) {
            this.productos[index].cantidad++
            console.log(index)
            // this.$set(this.productos[index], 'cantidad', this.productos[index].cantidad+1);
            console.log(this.productos[index])
        },
        decreaseQuantity(index) {
            this.productos[index].cantidad--
        },
    }
};
</script>
<template>
    <div>
        <h3 class="pl-3 pt-4">{{ titulo }}</h3>
        <div class="product-container">
            <div :class="windowWidth3>576 ? 'product-card' : 'product-sm-card'" v-for="(producto,index) in productos" :key="index">
                <div class="border pt-3 pb-3 text-center position-relative" >
                    <div v-if="producto.promocion" class="promotion-label">Promoción</div>
                    <a :href="'/producto/'+producto.id">
                        <img 
                            :src="producto.foto_dir === '' || producto.foto_dir === null 
                                ? '/images/productos_web/producto-sin-imagen.png' 
                                : producto.foto_dir" 
                            alt 
                            :class="windowWidth3 > 576 ? 'rounded avatar-3xl' : 'rounded avatar-lg'"
                        />
                    </a>
                </div>
                <p class="pt-2 m-0 text-danger font-size-12" v-if="producto.precio_rebajado!=null && producto.precio_rebajado!=0">Oferta - {{Math.round(producto.porcentaje)}}% OFF</p>
                <p class="pt-2 m-0 text-danger font-size-12" v-else><br></p>
                <!-- <p class="p-1 m-0 text-secondary font-size-10" v-for="cate in producto.cat" :key="cate.id">{{cate.nombre}}</p> -->
                <h2 class="product-title">
                    <a 
                        :href="'/producto/'+producto.id" 
                        class="text-dark" 
                        style="text-decoration: none;">
                        {{ producto.nombre }}
                    </a>
                </h2>
                <span v-if="producto.tipo=='Simple' && producto.estado_inventario=='hay'">
                    <p class="product-price" v-if="producto.precio_rebajado!=null"><del class="text-secondary">${{ producto.precio_normal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}</del> - ${{producto.precio_rebajado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</p>
                    <p class="product-price" v-else-if="producto.precio_normal || producto.precio_normal!=''">$ {{producto.precio_normal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</p>
                </span>
                <span v-else-if="producto.tipo=='Variable'">
                    <p class="product-price" v-if="producto.precio_rebajado!=0">Desde $ {{producto.precio_rebajado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</p>
                    <p class="product-price" v-else-if="producto.precio_normal|| producto.precio_normal!=''">Desde $ {{producto.precio_normal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</p>
                </span>
                <div class="m-0 p-0">
                    <p class="float-right text-primary font-size-12 m-0 p-0">
                        <a 
                            :href="'/filtrar/marca/'+producto.marca" 
                            class="text-primary" 
                            style="text-decoration: none;">
                            <b>{{ producto.nombre_marca }}</b>
                        </a>
                    </p>
                </div>
                <div class="mt-auto pt-2 p-0 m-0 card-footer" style="background-color: transparent;">
                    <div
                    class="d-flex flex-column align-items-center"
                    v-if="producto.tipo == 'Simple' && producto.stock > 0 && producto.estado_inventario == 'hay'"
                    >
                    <!-- Contenedor para los botones de cantidad -->
                        <div class="d-flex flex-row align-items-center">
                            <b-button variant="primary" @click="decreaseQuantity(index)" :disabled="producto.cantidad == 1" class="quantity-btn">-</b-button>
                            <span class="quantity mx-2">{{ producto.cantidad }}</span>
                            <b-button variant="primary" @click="increaseQuantity(index)" :disabled="producto.cantidad >= producto.stock" class="quantity-btn">+</b-button>
                        </div>

                        <!-- Contenedor para el botón del carrito -->
                        <div class="d-flex justify-content-center mt-2">
                            <b-button
                            variant="success"
                            :disabled="producto.cantidad < 1"
                            @click="agregar_carro(producto)"
                            >
                            <i class="fas fa-shopping-cart"></i>
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center" v-else>
                        <b-button variant="primary" block pill class="flex-fill" :href="'/producto/'+producto.id">
                            Ver opciones
                        </b-button>
                    </div>
                </div>
            </div>
        </div>                    
    </div>
</template>
<style>
.product-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.product-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    width: 250px;
    margin: 20px;
    display: flex;
    flex-direction: column;
}
.product-sm-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
   
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    width: 150px;
    margin: 10px;
    display: flex;
    flex-direction: column;
}

.product-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
}

.product-price {
    font-size: 14px;
    font-weight: bold;
    color: #556ee6;
    margin-top: auto;
}
</style>